<!--
	* @Description: 教职工请假记录 详情
	* @Author: PF
	* @Date: 2023-07-17 17:04:26.389
 * @LastEditors: PF
 * @LastEditTime: 2023-07-19 18:33:52
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openDetail" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Document />
          </el-icon>
          <span class="header-title">详情</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openDetail', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-descriptions :column="4" border>
        <el-descriptions-item label="请假开始时间" label-align="right" align="left" width="130px" span="2">{{ruleForm.qjkssj}}</el-descriptions-item>
        <el-descriptions-item label="请假结束时间" label-align="right" align="left" width="130px" span="2">{{ruleForm.qjjssj}}</el-descriptions-item>
        <el-descriptions-item label="请假天数" label-align="right" align="left" span="2">{{ruleForm.qjts}}</el-descriptions-item>
        <el-descriptions-item label="请假类型" label-align="right" align="left" span="2">{{ruleForm.qjlxbt}}</el-descriptions-item>
        <el-descriptions-item label="请假原因" label-align="right" align="left" span="4">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.qjyy"></p>
        </el-descriptions-item>
        <el-descriptions-item label="请假状态" label-align="right" align="left" span="2">
          <span v-for="(item, index) in qjztData.listZhuangTai" :key="index">
            <span v-if="ruleForm.zt==item.value">{{item.name}}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="申请时间" label-align="right" align="left" span="2">{{ruleForm.sqsj}}</el-descriptions-item>
        <el-descriptions-item label="生效时间" label-align="right" align="left" span="2">{{ruleForm.sxsj}}</el-descriptions-item>
        <el-descriptions-item label="生效操作人" label-align="right" align="left" span="2">{{ruleForm.sxczrxm}}</el-descriptions-item>
        <el-descriptions-item label="销假状态" label-align="right" align="left" span="2">
          <span v-for="(item, index) in xjztData.listZhuangTai" :key="index">
            <span v-if="ruleForm.xjzt==item.value">{{item.name}}</span>
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="销假时间" label-align="right" align="left" span="2">{{ruleForm.xjsj}}</el-descriptions-item>
        <el-descriptions-item label="销假操作人" label-align="right" align="left" span="2">{{ruleForm.xjczrxm}}</el-descriptions-item>
        <el-descriptions-item label="实际请假天数" label-align="right" align="left" span="2">{{ruleForm.sjqjts}}</el-descriptions-item>
        <el-descriptions-item label="实际请假开始时间" label-align="right" align="left" width="140px" span="2">{{ruleForm.sjqjkssj}}</el-descriptions-item>
        <el-descriptions-item label="实际请假结束时间" label-align="right" align="left" width="140px" span="2">{{ruleForm.sjqjjssj}}</el-descriptions-item>
        <el-descriptions-item label="审批通过时间" label-align="right" align="left" span="2">{{ruleForm.sptgsj}}</el-descriptions-item>
        <el-descriptions-item label="拒绝原因" label-align="right" align="left" span="4">
          <p style="white-space: pre-wrap; text-indent:0;" v-html="ruleForm.jjyy"></p>
        </el-descriptions-item>
        <el-descriptions-item label="是否需要调代课" label-align="right" align="left" span="2">
          <span v-if="ruleForm.sfxqtdk==true">是</span>
          <span v-if="ruleForm.sfxqtdk==false">否</span>
        </el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="info" @click="closeWindow('openDetail', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineEmits, ref, defineProps, watch } from 'vue'
import { loadData, closeWindow, loadSelect } from '@/api/common.js'
import { loadZiDianSelect } from '@/api/queryZiDian.js'

const props = defineProps({
  openDetail: { type: Boolean, required: true },
  row: { type: Object, required: false }
})
const emits = defineEmits(['update:openDetail'])
const ruleForm = ref({})
const jzgqjlxData = ref() // 教职工请假类型
const qjztData = ref({}) // 教职工请假状态
const xjztData = ref({}) // 教职工销假状态

watch(
  () => props.openDetail,
  () => {
    if (props.openDetail) {
      loadSelect({ url: '/api/v2/jiaowu/jiaozhigongqingjiajilu/jiaozhigongzhuangtai', data: qjztData })
      loadSelect({ url: '/api/v2/jiaowu/jiaozhigongqingjiajilu/jiaozhigongxiaojiazhuangtai', data: xjztData })
      loadZiDianSelect('教职工请假类型', jzgqjlxData, 'sx', 'asc')
      loadData({
        url: '/api/v2/jiaowu/jiaozhigongqingjiajilu/' + props.row.id,
        ruleForm
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
